import { usePermissionStore } from '@/stores/permission/index';
import type { IPermission } from '~/types/permission/Types';

export default defineNuxtRouteMiddleware(async (to, from) => {
    const publicPaths = ['', 'auth/login', 'login', 'auth/forgot-password', 'set-password'];
    try {
        let toPath = to.path.replace(/^\/|\/$/g, '');
        if (publicPaths.includes(toPath)) {
            return;
        }
        
        const permissionStore = usePermissionStore();
        var { rolePermissionPersist } = permissionStore;
        let map = new Map (rolePermissionPersist.map(o => [o[0], o[1]])) as Map<string, IPermission>;
        let permission;
        if (map.has(toPath)) {
            permission = map.get(toPath)?.visible ?? false;
        } else {
            const baseRoute = toPath.split('/').slice(0, -1).join('/');
            permission = map.get(baseRoute)?.visible ?? false;
        }
        if (permission) {
            return;
        }
        
        return navigateTo('/');
    } catch (error) {
        return navigateTo('/');
    }
})